import React, { useState, useEffect } from 'react';
import HeaderLogged from './components/header_logged';
import Container from './components/container';
import api from './api/client';
import EditAmazonShipmentPopup from './components/EditAmazonShipmentPopup';

const ScannersAmazonShipments = () => {
    const [needToShip, setNeedToShip] = useState([]);
    const [editIncomplete, setEditIncomplete] = useState([]);
    const [selectedShipment, setSelectedShipment] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isNeedToShipExpanded, setIsNeedToShipExpanded] = useState(true);
    const [isEditIncompleteExpanded, setIsEditIncompleteExpanded] = useState(false);

    // Запросы к API
    const fetchNeedToShip = async () => {
        try {
            const response = await api.get(`/api/amz-shipments-need-to-ship`);
            setNeedToShip(response.data.data);
        } catch (error) {
            console.error('Error fetching need to ship:', error);
        }
    };

    const fetchEditIncomplete = async () => {
        try {
            const response = await api.get(`/api/amz-shipments-incomplete`);
            setEditIncomplete(response.data.data);
        } catch (error) {
            console.error('Error fetching edit incomplete:', error);
        }
    };

    useEffect(() => {
        fetchNeedToShip();
        fetchEditIncomplete();
    }, []);

    // Обработчики попапа
    const handleOpenPopup = (shipment) => {
        api.get(`/api/edit-amz-shipments/${shipment.ShipmentID}`)
            .then(response => {
                setSelectedShipment(response.data);
                setIsPopupOpen(true);
            })
            .catch(error => console.error('Error fetching shipment details:', error));
    };

    const handlePopupSubmit = () => {
        fetchNeedToShip();
        fetchEditIncomplete();
        setIsPopupOpen(false);
    };

    // Рендер списка
    const renderShipmentList = (shipments, isExpanded) => (
        <div className="sc-amz-shipment-list">
            {isExpanded && shipments.map(shipment => (
                <div key={shipment.ShipmentID} className="sc-amz-shipment-item">
                    <div className="sc-amz-shipment-info">
                        <span className="sc-amz-shipment-id">Shipment ID: {shipment.ShipmentID}</span>
                        <span className="sc-amz-pickup-date">Pickup Date: {shipment.pickup_date}</span>
                    </div>
                    <button 
                        className="sc-amz-action-btn"
                        onClick={() => handleOpenPopup(shipment)}
                    >
                        {shipment.statusName === 'Need to ship' ? 'Edit Boxes' : 'Add Boxes'}
                    </button>
                </div>
            ))}
        </div>
    );

    return (
        <div className="sc-amz-page">
            <HeaderLogged />
            <Container>
                <h1 className="sc-amz-header-h">Amazon Shipments</h1>
                <div className="sc-amz-section">
                    <div className="sc-amz-header" onClick={() => setIsNeedToShipExpanded(!isNeedToShipExpanded)}>
                        <h2>Need to ship ({needToShip.length})</h2>
                        <span>{isNeedToShipExpanded ? '▼' : '▶'}</span>
                    </div>
                    {renderShipmentList(needToShip, isNeedToShipExpanded)}
                </div>

                <div className="sc-amz-section">
                    <div className="sc-amz-header" onClick={() => setIsEditIncompleteExpanded(!isEditIncompleteExpanded)}>
                        <h2>Edit incomplete ({editIncomplete.length})</h2>
                        <span>{isEditIncompleteExpanded ? '▼' : '▶'}</span>
                    </div>
                    {renderShipmentList(editIncomplete, isEditIncompleteExpanded)}
                </div>
            </Container>

            <EditAmazonShipmentPopup
                isOpen={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
                onSubmit={handlePopupSubmit}
                shipmentData={selectedShipment}
            />
        </div>
    );
};

export default ScannersAmazonShipments;